<div class="overlay">
  <div class="dialog-confirm" cdkDrag>
    <div class="title">{{ title | translate }}</div>

    <div class="content">
      {{ message | translate }}
    </div>

    <div class="btn-area w-100">
      <button class="cancel-btn" (click)="onCancel()">{{ 'common.confirm.btn.no' | translate }}</button>
      <button class="save-btn" (click)="onConfirm()">{{ 'common.confirm.btn.yes' | translate }}</button>
    </div>
  </div>
</div>
<ng-content></ng-content>